import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const WithdrawShrapIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 19.0909H5V15H6V18.0909H17V15H18V19.0909Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5.91435V15.3435H12V5.91409L16.2375 10.1516L16.9446 9.44447L11.5001 4L6.05566 9.44447L6.76277 10.1516L11 5.91435Z"
      fill="currentColor"
    />
  </svg>,
  'WithdrawShrapIcon'
);
